import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, user } = useAuth();

  useEffect(() => {
    console.log('HomePage Debug:', {
      isAuthenticated,
      isAdmin: isAdmin(),
      user,
      userRole: user?.Role || user?.role
    });
    
    if (!isAuthenticated) {
      navigate('/login');
    } else if (isAdmin()) {
      navigate('/admin');
    } else {
      navigate('/dashboard');
    }
  }, [isAuthenticated, isAdmin, navigate, user]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <p>Weiterleitung...</p>
    </div>
  );
};

export default HomePage;